// Interfaces for Tenant-Wide Orphaned Workspaces Report

import { IRequestModel } from "./reports-common.interfaces";

// Enum for workspace owner invalid reasons
export enum WorkspaceOwnerInvalidReason {
    None = 0,
    NotInDirectory = 1,
    AccountDisabled = 2,
    NoLicense = 3
}

// Owner model for orphaned workspaces
export interface IWorkspaceOwner {
    objectId: string;
    displayName: string;
    email: string;
    upn: string;
    isActiveOwner: boolean;
    reasonInvalid: WorkspaceOwnerInvalidReason;
}

// Report item for orphaned workspaces in tenant
export interface IOrphanedWorkspacesInTenantReportItem {
    workspaceName: string;
    workspaceUrl: string;
    workspaceType: string; // "Team" | "SiteCollection" | "OneDrive"
    workspaceTemplate: string; // e.g., "GROUP#0", "SITEPAGEPUBLISHING#0"
    owners: IWorkspaceOwner[];
}

// Report details/summary for orphaned workspaces in tenant
export interface IOrphanedWorkspacesInTenantReportDetails {
    totalOrphanedWorkspaces: number;
    generatedOn: string;
    includedWorkspaces: boolean;
    includedOneDrives: boolean;
}
